import { CommonIP } from '@model/ftf-api.model';
import { createAction, props } from '@ngrx/store';

export const loadHistory = createAction('[History] Load History');

export const loadHistorySuccess = createAction('[History] Load History Success', props<{ items: CommonIP[] }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadHistoryFailure = createAction('[History] Load History Failure', props<{ error: any }>());

export const addHistoryItem = createAction('[History] Add History Item', props<{ item: CommonIP }>());

export const addHistoryItemSuccess = createAction('[History] Add History Item Success', props<{ items: CommonIP[] }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addHistoryItemFailure = createAction('[History] Add History Item Failure', props<{ error: any }>());
